import React from "react";
const DocumentJson = (document) => {

    return (
        <pre>
            {JSON.stringify(document, null, 2)}
        </pre>
    );
};
export default DocumentJson;